import React from 'react'
import { YAxis, YAxisProps } from 'recharts'

const CustomYAxis = (props?: YAxisProps) => {
  return (
    <YAxis
      tickLine={false}
      axisLine={false}
      tickSize={0}
      interval={0}
      scale="linear"
      stroke="#858FAD"
      tick={({ x, y, payload }) => (
        <text
          x={props?.orientation === 'right' ? x + 10 : x - 10}
          y={y + 4}
          textAnchor={props?.orientation === 'right' ? 'start' : 'end'}
          fill="#858FAD"
          fontSize={12}
          fontWeight={400}
          fontFamily="Navigo"
        >
          {`${payload.value}${props?.unit ? ` ${props.unit}` : ''}`}
        </text>
      )}
      {...props}
    />
  )
}

export default CustomYAxis
